export default function XML_Attributes() {
  return (
    <div>
      <h1>XML_Attributes</h1>
      <p>This is the XML_Attributes component.</p>
    </div>
  );
}